<template>
  <div class="main-container">
    <v-container class="pa-0" fluid>
      <div class="header-holder pl-3 pl-md-0 py-5">
        <h1 class="header">
          {{ $t("app_bar.title_graduate") }}
        </h1>
        <h4 class="sub-header">
          {{ $t("app_bar.university_name") }}
        </h4>
      </div>
      <LauncherTabs :page="page" />
      <v-card
        :disabled="loading"
        :loading="loading"
        color="rgb(255, 255, 255, 0.6)"
        class="pa-5"
      >
        <v-row>
          <v-col class="col-12 col-md-12">
            <h4>{{ $t("explore.select_faculty_to_search") }}</h4>
            <v-autocomplete
              chips
              clearable
              dense
              deletable-chips
              multiple
              outlined
              v-model="facultiesSelected"
              v-bind:items="faculties"
              v-bind:item-text="
                (item) => objectTranslator(item, 'FACULTY_NAME')
              "
              v-bind:item-value="(item) => item.FACULTY_ID"
              hide-details
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <div class="news-container pa-0 pa-sm-3 pa-xl-6">
          <v-card>
            <v-tabs v-model="tab" center-active dark>
              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab href="#tab-1">{{
                $t("announcement_graduate.announcement_pdf_file")
              }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" touchless>
              <v-tab-item
                v-for="(item_main, i) in news_type"
                :key="i"
                :value="item_main.tab_id"
              >
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>
                          {{ $t("announcement_graduate.title") }}
                        </th>
                        <th>
                          {{ $t("announcement_graduate.detail") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in item_main.type"
                        v-bind:key="item.news_id"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a
                            v-bind:href="item.link1"
                            target="_blank"
                            style="text-decoration: none"
                            >{{
                              inlineTranslator({
                                en: item.topic_en,
                                th: item.topic,
                              })
                            }}</a
                          >
                          <br />
                          <span style="float: left">
                            <v-chip
                              class="ma-2"
                              color="#A9A9A9"
                              text-color="white"
                              x-small
                            >
                              {{ objectTranslator(item, "FACULTY_NAME") }}
                            </v-chip></span
                          >
                          <span style="float: right" class="grey--text">
                            { {{ item.date_time }} }
                          </span>
                        </td>
                        <td>
                          <span v-if="item.link1 && item.link2">
                            <div class="d-flex">
                              <ButtonNews
                                v-bind:text="filetype(item.link1)"
                                v-bind:link="item.link1"
                                color="primary"
                                class="mr-1"
                              />

                              <ButtonNews
                                v-bind:text="filetype(item.link2)"
                                v-bind:link="item.link2"
                                color="primary"
                              />
                            </div>
                          </span>
                          <span v-else>
                            <ButtonNews
                              v-bind:text="$t('announcement_graduate.detail')"
                              v-bind:link="item.link1"
                              color="primary"
                              mdi="mdi-link-variant"
                            />
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import ButtonNews from "@/components/announcement/ButtonNews";
import AnnouncementProvider from "@/services/announcement.provider";
import FacultyProvider from "@/services/faculty.provider";
import LauncherTabs from "@/components/explore_page/LauncherTabs";
import { getById } from "@/helper/filter";

const announcementProvider = new AnnouncementProvider();
const facultyProvider = new FacultyProvider();

export default {
  name: "AnnoucementFileDownload",
  data: function () {
    return {
      page: "graduate_announcement",
      tab: null,
      index: 1,
      loading: false,

      faculties: [],
      facultiesSelected: [],

      news_main_pdf_file: [],
    };
  },
  components: {
    LauncherTabs,
    ButtonNews,
  },
  methods: {
    objectTranslator,
    inlineTranslator,

    filetype: function (filename) {
      const re = /(?:\.([^.]+))?$/;
      return re.exec(filename)[1];
    },

    async fetch_data() {
      const facultys = await facultyProvider.getFaculties();
      this.faculties = facultys;

      const data2 =
        await announcementProvider.getNewsGraduate_annoucement_pdf_files({});
      data2.map((item) => {
        if (item.faculty_id) {
          const ref_data = getById(
            this.faculties,
            item.faculty_id,
            "FACULTY_ID"
          );
          item.FACULTY_NAME_EN = ref_data.FACULTY_NAME_EN;
          item.FACULTY_NAME_TH = ref_data.FACULTY_NAME_TH;
        }
        return item;
      });
      this.news_main_pdf_file = data2;
    },
  },
  computed: {
    filtered_news_main_pdf_file() {
      if (this.facultiesSelected.length === 0) {
        return this.news_main_pdf_file;
      }

      return this.news_main_pdf_file.filter((item) =>
        this.facultiesSelected.includes(item.faculty_id)
      );
    },

    news_type() {
      return [
        {
          tab_id: "tab-1",
          type: this.filtered_news_main_pdf_file,
        },
      ];
    },
  },
  mounted: function () {
    this.loading = true;
    this.fetch_data();
    if (this.$route.query.tab) this.tab = this.$route.query.tab;
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.topic-container {
  background-color: #fffa;
  padding: 5px 25px 25px 25px;
  display: flex;
  flex-direction: column;
}
.main-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.header-holder {
  padding-bottom: 20px;
}

.header {
  color: rgb(255, 255, 255);
  text-shadow: 1px 1px 1px #000000cc;
  font-weight: bold;
}

.sub-header {
  color: #ff3c00;
  background-color: rgba(255, 255, 255, 0.5);
  // padding: 0px 10px 0px 10px;
  width: auto;
  font-weight: bold;
}

.news-container {
  background-color: #0005;
  // padding: 20px;
}
</style>
